import { render, staticRenderFns } from "./EditContacts.vue?vue&type=template&id=0abb1be8&scoped=true&"
import script from "./EditContacts.vue?vue&type=script&lang=js&"
export * from "./EditContacts.vue?vue&type=script&lang=js&"
import style0 from "./EditContacts.vue?vue&type=style&index=0&id=0abb1be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb1be8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VIcon})
